module.exports = __webpack_public_path__ + "img/liwu.5f136d0a.png";